import React, { Component } from "react";
import AddBook from "../AddBook/AddBook";

class EditBook extends Component {
  render() {
    return (
      <AddBook editStatus={true} bookId={this.props.match.params.bookId} />
    );
  }
}

export default EditBook;
